import React from 'react'
import { Link } from 'react-router-dom'
import { MdEmail, MdLocationOn } from "react-icons/md";
import { FaLinkedin, FaWhatsapp } from "react-icons/fa";

function Footer() {
    const currentDate = new Date()
    return (
        <footer className='pt-12 bg-base-100 border-t border-base-200 mt-20'>
            <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">

                    <div className="md:col-span-2">
                        <Link to={'/'} className="inline-block mb-4">
                            <h2 className="text-2xl font-bold uppercase">Health<span className="text-primary">Connect</span></h2>
                        </Link>
                        <p className="text-gray-500 text-sm max-w-sm mb-6">
                            Connecting Kenyan families with verified nurses for hospital-grade healthcare at home.
                        </p>
                        <div className="flex items-center gap-2 text-gray-500 text-sm mb-4">
                            <MdLocationOn className="text-primary" />
                            <span>Nairobi, Kenya</span>
                        </div>
                        <div className="flex items-center gap-2 text-gray-500 text-sm">
                            <MdEmail className="text-primary" />
                            <span>support@healthconnect.co.ke</span>
                        </div>
                    </div>

                    <div>
                        <h4 className="font-bold text-sm uppercase tracking-wider text-gray-400 mb-4">Quick Links</h4>
                        <ul className="space-y-3">
                            <li>
                                <Link className="text-sm text-gray-500 hover:text-primary transition-colors" to={'/'}>
                                    Home
                                </Link>
                            </li>
                            <li>
                                <Link className="text-sm text-gray-500 hover:text-primary transition-colors" to={'/about'}>
                                    About Us
                                </Link>
                            </li>
                            <li>
                                <Link className="text-sm text-gray-500 hover:text-primary transition-colors" to={'/services'}>
                                    Services
                                </Link>
                            </li>
                            <li>
                                <Link className="text-sm text-gray-500 hover:text-primary transition-colors" to={'/help'}>
                                    Help & Support
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-bold text-sm uppercase tracking-wider text-gray-400 mb-4">Legal</h4>
                        <ul className="space-y-3">
                            <li>
                                <Link className="text-sm text-gray-500 hover:text-primary transition-colors" to={'/privacy'}>
                                    Privacy Policy
                                </Link>
                            </li>
                            <li>
                                <Link className="text-sm text-gray-500 hover:text-primary transition-colors" to={'/terms'}>
                                    Terms of Service
                                </Link>
                            </li>
                            <li>
                                <Link className="text-sm text-gray-500 hover:text-primary transition-colors" to={'/contact'}>
                                    Contact Us
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="flex justify-center items-center gap-4 mb-8">
                    <a href="https://linkedin.com/company/healthconnect" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary transition-colors">
                        <FaLinkedin size={24} />
                    </a>
                    <a href="https://wa.me/254700000000" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary transition-colors">
                        <FaWhatsapp size={24} />
                    </a>
                    <a href="mailto:support@healthconnect.co.ke" className="text-gray-400 hover:text-primary transition-colors">
                        <MdEmail size={24} />
                    </a>
                </div>

                <div className="border-t border-base-200 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-sm text-gray-500 text-center md:text-left">
                        © {currentDate.getFullYear()} HealthConnect. All rights reserved.
                    </p>
                    <p className="text-sm text-gray-500 flex items-center gap-2">
                        <MdLocationOn className="text-primary" />
                        Made with ❤️ in Kenya
                    </p>
                </div>
            </div>
        </footer>
    )
}

export default Footer